<template>
    <pca-button-dictionary ref="bdRef" title="Журнал печати">
        <div class="flex h-full w-full flex-col gap-3">
            <pca-grid-ro-print-result ref="gridRef"> </pca-grid-ro-print-result>
        </div>
    </pca-button-dictionary>
</template>
<script>
export default {
    name: 'pcaPrintResult',
};
</script>

<script setup>
import { ref } from 'vue';

import PcaButtonDictionary from '@/views/contracts/print-contract/components/pca-button-dictionary.vue';
import PcaGridRoPrintResult from '@/views/contracts/print-contract/components/pca-grid-ro-print-result.vue';

const bdRef = ref(null);
const gridRef = ref(null);

async function refreshData(dataSource) {
    if (gridRef.value) {
        await gridRef.value.setPrintResult(dataSource);
    }
}

function viewPopup() {
    bdRef.value.changePopupVisibility(true);
}

defineExpose({
    refreshData,
    viewPopup,
});
</script>
